import Types from "./Types";

export const getAllCoursesRequest = (body) => ({
  type: Types.GET_COURSES_REQUEST,
  payload: body,
});

export const getAllCoursesSuccess = (data) => ({
  type: Types.GET_COURSES_SUCCESS,
  payload: data,
});

export const getAllCoursesFail = () => ({
  type: Types.GET_COURSES_FAIL,
});

export const editCourseRequest = (formData, action) => ({
  type: Types.EDIT_COURSE_REQUEST,
  payload: formData,
  action: action,
});

export const editCourseSuccess = (data) => ({
  type: Types.EDIT_COURSE_SUCCESS,
  payload: data,
});

export const editCourseFail = () => ({
  type: Types.EDIT_COURSE_FAIL,
});

export const restrictCourseRequest = (formData, action) => ({
  type: Types.RESTRICT_COURSE_REQUEST,
  payload: formData,
  action: action,
});

export const restrictCourseSuccess = (data) => ({
  type: Types.RESTRICT_COURSE_SUCCESS,
  payload: data,
});

export const restrictCourseFail = () => ({
  type: Types.RESTRICT_COURSE_FAIL,
});
export const asqueraCourseRequest = (formData, action) => ({
  type: Types.ASQUARA_COURSE_REQUEST,
  payload: formData,
  action: action,
});

export const asqueraCourseSuccess = (data) => ({
  type: Types.ASQUARA_COURSE_SUCCESS,
  payload: data,
});

export const asqueraCourseFail = () => ({
  type: Types.ASQUARA_COURSE_FAIL,
});
export const activeCourseRequest = (formData, action) => ({
  type: Types.ACTIVE_COURSE_REQUEST,
  payload: formData,
  action: action,
});

export const activeCourseSuccess = (data) => ({
  type: Types.ACTIVE_COURSE_SUCCESS,
  payload: data,
});

export const activeCourseFail = () => ({
  type: Types.ACTIVE_COURSE_FAIL,
});
//LOADING
export const addCourseLoading = (isLoading) => ({
  type: Types.ADD_COURSES_LOADING,
  payload: isLoading,
});

// Create Course
export const createCourseRequest = (formData, action) => ({
  type: Types.CREATE_COURSE_REQUEST,
  payload: formData,
  action: action,
});

export const createCourseSuccess = ({ data }) => ({
  type: Types.CREATE_COURSE_SUCCESS,
  payload: {
    data,
  },
});

export const createCourseFail = () => ({
  type: Types.CREATE_COURSE_FAIL,
});

export const deleteCourseRequest = (id) => ({
  type: Types.DELETE_COURSE_REQUEST,
  payload: id,
});

export const deleteCourseSuccess = (id) => ({
  type: Types.DELETE_COURSE_SUCCESS,
  payload: id,
});

export const deleteCourseFail = () => ({
  type: Types.DELETE_COURSE_FAIL,
});

export const approveStudentEnrollCourseRequest = (formData, action) => ({
  type: Types.APPROVE_SUPERADMIN_STUDENT_ENROLL_COURSE_REQUEST,
  payload: formData,
  action: action,
});

export const approveStudentEnrollCourseSuccess = (data) => ({
  type: Types.APPROVE_SUPERADMIN_STUDENT_ENROLL_COURSE_SUCCESS,
  payload: data,
});

export const approveStudentEnrollCourseFail = () => ({
  type: Types.APPROVE_SUPERADMIN_STUDENT_ENROLL_COURSE_FAIL,
});

export const rejectStudentEnrollCourseRequest = (formData, action) => ({
  type: Types.REJECT_SUPERADMIN_STUDENT_ENROLL_COURSE_REQUEST,
  payload: formData,
  action: action,
});

export const rejectStudentEnrollCourseSuccess = (data) => ({
  type: Types.REJECT_SUPERADMIN_STUDENT_ENROLL_COURSE_SUCCESS,
  payload: data,
});

export const rejectStudentEnrollCourseFail = () => ({
  type: Types.REJECT_SUPERADMIN_STUDENT_ENROLL_COURSE_FAIL,
});

export const getAllEnrollCourseRequest = (body) => ({
  type: Types.GET_STUDENT_ENROLL_COURSE_REQUEST,
  payload: body,
});

export const getAllEnrollCourseSuccess = (data) => ({
  type: Types.GET_STUDENT_ENROLL_COURSE_SUCCESS,
  payload: data,
});

export const getAllEnrollCourseFail = () => ({
  type: Types.GET_STUDENT_ENROLL_COURSE_FAIL,
});
